import React from "react";
import { Chip } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { customFilterHeaderStyles } from "./CustomFilterHeaderStyles";
import { InarixGridFilterModel } from "../../../../redux/slices/dataTable/data";

interface CustomFilterHeaderProps {
  field: string;
  filterModel: InarixGridFilterModel;
}

const CustomFilterHeader: React.FC<CustomFilterHeaderProps> = ({ field, filterModel }) => {

  const columnFiltersCount =
    filterModel?.items?.filter(
      (item) => item.field === field && item.operator && item.value
    ).length || 0;

  if (columnFiltersCount === 0) {
    return null;
  }

  return (
    <div style={customFilterHeaderStyles.container}>
      <FilterAltIcon sx={customFilterHeaderStyles.filterIcon} />
      <Chip
        label={columnFiltersCount}
        size="small"
        sx={customFilterHeaderStyles.filterChip}
      />
    </div>
  );
};

export default CustomFilterHeader;
